
import BuySellYourHomeSection from '../section';
import { StylePositionType, StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import routes from '@/constants/routes';
import Gutter from '@/ui-kit/components/gutter';
import Button from '@/ui-kit/components/button';
import SellYourHomeStoreName from '@/store/sell-your-home/name';
import BuySellYourHomeCarousel from './carousel';

export default {
  name: 'SellYourHomeCarouselSection',
  components: {
    BuySellYourHomeSection,
    BuySellYourHomeCarousel,
    Gutter,
    Button,
  },
  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
    storeName: {
      type: String,
      required: true,
    },
    trackEvent: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      routes,
      StyleColorSchemeType,
      StylePositionType,
      StyleSizeType,
    };
  },
  computed: {
    questionContent() {
      return this.$store.state[this.storeName].questionContent;
    },
    isSellYourHome() {
      return this.storeName === SellYourHomeStoreName;
    },
  },
  methods: {
    handleStartListingClick() {
      const { userId, email } = this.user;

      this.$track('Sell your home_FAQ section_button click', {
        userId,
        email,
      });
    },
  },
};
